module.exports = __webpack_public_path__ + "img/intro_uk.f06fc932.svg";